import { render } from "./ShareButton.vue?vue&type=template&id=8c1f41e2&scoped=true"
import script from "./ShareButton.vue?vue&type=script&lang=js"
export * from "./ShareButton.vue?vue&type=script&lang=js"

import "./ShareButton.vue?vue&type=style&index=0&id=8c1f41e2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\clha\\Documents\\Development\\interflon-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c1f41e2"]])

export default __exports__